export default __webpack_public_path__ + "/dist/images/password-active.613232625baf5e530f1d105769435a3d.svg";